<template>
  <div class="space-y-6 col-span-1">
    <div class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full"
    >
      <div class="px-4 py-3 sm:px-4">
        <div
          class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap"
        >
          <div class="ml-4 mt-2">
            <h3 class="text-base leading-6 font-medium text-gray-900">
              {{ $t('message.reports.maintenance.maintenance') }} : <b>{{this.currentDevice.name}}</b>
            </h3>
          </div>
          <div class="ml-2 mt-2 flex-shrink-0">
            <button
              @click="downloadExcel"
              type="button"
              class="relative inline-flex items-center px-2 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <svg
                v-if="downloading"
                class="animate-spin -ml-1 mr-3 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {{ $t('message.reports.detenciones.descargarexcel') }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="chart==='maintenance'">
        <div class="px-4 py-6" v-if="reportnav.mttr_mtbf !== undefined ? reportnav.mttr_mtbf : false">
          <h3 class="text-base items-center leading-6 font-medium text-gray-900 pr-2">
            MTTR - MTBF
          </h3>
          <vue-apex-charts
            type="line"
            height="250"
            :options="mtbfChartOptions"
            :series="mttr_mtbf">
          </vue-apex-charts>
        </div>
        <div class="px-4 py-6" v-if="reportnav.mtbf !== undefined ? reportnav.mtbf : false">
          <h3 class="text-base items-center leading-6 font-medium text-gray-900 pr-2">
            MTBF
          </h3>
          <vue-apex-charts
            type="line"
            height="250"
            :options="mtbfChartOptions"
            :series="mtbf"
            >
          </vue-apex-charts>
        </div>
        <div class="px-4 py-6" v-if="reportnav.mttr !== undefined ? reportnav.mttr : false">
          <h3 class="text-base items-center leading-6 font-medium text-gray-900 pr-2">
            MTTR
          </h3>
          <vue-apex-charts
            type="line"
            height="250"
            :options="mttrChartOptions"
            :series="mttr">
          </vue-apex-charts>
        </div>
        <div class="px-4 py-6" v-if="reportnav.dispmaintenance !== undefined ? reportnav.dispmaintenance : false">
          <h3 class="text-base items-center leading-6 font-medium text-gray-900 pr-2">
            {{ $t('message.reports.maintenance.dispmaintenance') }}
          </h3>
          <vue-apex-charts
            type="bar"
            height="250"
            :options="chartOptions"
            :series="dispmaintenance">
          </vue-apex-charts>
        </div>
      </div>
    </div>
    <data-table :headers="headers" :rows="rows" class='h-128' v-on:item-dblclick="(row) => {this.openModal(row)}" />

    <dynamic-form v-on:toggle-form="toggleValidationModal" v-if="validationmodal" formtype='maintenancevalidation' :params="params"/>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable/DataTable'
import DynamicForm from '@/components/DynamicForm/DynamicForm'
import VueApexCharts from 'vue-apexcharts'
import { getUnixTime } from 'date-fns'
import axios from 'axios';
export default {
  name: 'report-mantenimiento',
  components: { VueApexCharts, DataTable, DynamicForm },
  mounted() {
    this.fetchData()
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    currentDevice: {
      type: Object,
      required: true
    },
    reportnav: {
      type: Object
    }
  },
  watch: {
    range() {
      this.fetchData()
    },
    currentDevice() {
      this.fetchData()
    }
  },
  methods: {
    async fetchData() {
      let start = getUnixTime(this.range.start)
      let end = getUnixTime(this.range.end)

      const mantenimiento = await this.$http.get(`/reports?report=mantenimiento&devid=${this.currentDevice.devid}&start=${start}&end=${end}`)
      this.rows = mantenimiento.data

      const headers = await this.$http.get(`/tables?table=mantenimiento`)
      this.headers = headers.data

      const mtbfresponse = await this.$http.get(`/reports?report=mtbf&devid=${this.currentDevice.devid}&start=${start}&end=${end}`)
      const mttrresponse = await this.$http.get(`/reports?report=mttr&devid=${this.currentDevice.devid}&start=${start}&end=${end}`)
      this.mttr = [{name: 'mttr', data: mttrresponse.data}]
      this.mtbf = [{name: 'mtbf', data: mtbfresponse.data}]
      this.mttr_mtbf = [{name: 'mtbf', data: mtbfresponse.data}, {name: 'mttr', data: mttrresponse.data}]

      if (this.reportnav.dispmaintenance !== undefined ? this.reportnav.dispmaintenance : false){
        let res = await this.$http.get(`/reports?report=dispmaintenance&devid=${this.currentDevice.devid}&start=${start}&end=${end}`)
        this.dispmaintenance = [{name: 'Disp. Mantenimeinto', data: res.data}]
      }

    },
    openModal(row) {
      this.params = row
      this.toggleValidationModal()
    },
    toggleValidationModal() {
      this.validationmodal = !this.validationmodal
    },
    async downloadExcel() {
      this.downloading = true;
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const url = `reports?report=reportmant&start=${start}&end=${end}&device=${this.currentDevice.devid}`;
      let response = await this.$http.get(url);
      if (response.status === 200) {
        const baseURL = process.env.VUE_APP_ROOT_API;
        const url = baseURL + 'reports?report=get_report&filename=' + response.data;
        axios
          .get(url, { responseType: 'blob', headers: {'Authorization': `JWT ${this.$store.getters.auth.token}`}})
          .then(r => {
            const blob = new Blob([r.data], {
              type: 'application/vnd.ms-excel'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            console.log('response', response.data);
            link.download = response.data;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }
      this.downloading = false;
    }

  },
  data() {
    return {
      chart: 'maintenance',
      params: {},
      validationmodal: false,
      headers: [],
      rows: [],
      downloading: false,
      mttr_mtbf: [],
      mttr: [],
      mtbf: [],
      dispmaintenance: [],
      mtbfChartOptions: {
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 5,
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val
            }
          }
        }
      },
      series: [],
      chartOptions: {
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: true
          },
          tooltip: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
          },
        },
        theme: {
          palette: "palette1"
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val + "%"
            }
          }
        }
      },
      mttrChartOptions: {
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        colors: ['#00E396'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 5,
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val
            }
          }
        }
      }
    }
  }
}
</script>
